import { render, staticRenderFns } from "./CardStatistics.vue?vue&type=template&id=66b2159b"
import script from "./CardStatistics.vue?vue&type=script&lang=js"
export * from "./CardStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports